import _ from "lodash";
// import { ProductForm } from '@shopify/theme-product-form'

class ProductFormElement extends HTMLElement {
  constructor() {
    super();
    this.isCustomily = document
      .querySelector("product-main")
      .getAttribute("customily");

    if (this.dataset.variants) {
      this.variants = JSON.parse(this.dataset.variants);
    }
    this.gallery = document.querySelector("product-gallery");

    const formEl = this.querySelector("form");

    formEl.addEventListener("change", (event) => {
      if (event.target.closest("[data-option]")) {
        this.onOptionChange(event);
      }
    });

    formEl.addEventListener("submit", (event) => {
      event.preventDefault();
      document.querySelector("shopify-cart").addItemFromForm(event.target);
    });

    if (this.isCustomily != "true") {
      if (
        this.gallery.querySelector(
          "div.image[attached-variant='" +
            this.querySelector('input[name="id"]').value +
            "']"
        )
      ) {
        this.gallery.ShowSelectedID(
          this.querySelector('input[name="id"]').value
        );
      } else {
        let selects = this.querySelectorAll("select[gallery_relevant]");
        if (selects) {
          this.gallery.ShowSelectedType(selects[selects.length - 1].value);
        }
      }
    }
  }

  backInStock(event) {
    event.preventDefault();
    let email_field = this.querySelector("#backinstockemail");
    let error_message = this.querySelector("#backinstockemail + .hidden");
    let button = this.querySelector("#backinstockemail ~ button");
    let email = email_field.value;
    let variant = this.querySelector("form").id.value;
    if (email == "") {
      // missing email
      error_message.classList.remove("hidden");
      return;
    }
    fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      body: new URLSearchParams({
        a: "VhnDTq",
        email: email,
        variant: variant,
        platform: "shopify",
      }),
    }).then((response) => {
      if (response.status == 200) {
        error_message.classList.add("hidden");
        email_field.classList.add("send");
        email_field.classList.add("hidden");
        //subscribed
        button.classList.remove("btn-primary", "text-anna-gray");
        button.classList.add(
          "bg-white",
          "border",
          "border-black",
          "cursor-default",
          "text-anna-black"
        );
        button.setAttribute("onclick", "event.preventDefault();");
        button.setAttribute("disabled", "");
        if (window.location.pathname.includes("/en")) {
          button.innerHTML = "Notification active";
        } else {
          button.innerHTML = "Benachrichtigung aktiv";
        }
      }
      if (response.status == 400) {
        error_message.classList.remove("hidden");
      }
    });
  }

  onOptionChange(event) {
    const formEl = this.querySelector("form");

    const option1 = formEl.querySelector('[data-option="1"]');
    const option2 = formEl.querySelector('[data-option="2"]');
    const option3 = formEl.querySelector('[data-option="3"]');

    if (
      this.isCustomily != "true" &&
      event.target.hasAttribute("gallery_relevant")
    ) {
      this.gallery.ShowSelectedType(event.target.value || null);
    }

    const matchingVariant = _.find(this.variants, {
      option1: option1?.value || null,
      option2: option2?.value || null,
      option3: option3?.value || null,
    });

    if (this.isCustomily != "true") {
      if (
        this.gallery.querySelector(
          "div.image[attached-variant='" + matchingVariant.id + "']"
        )
      ) {
        this.gallery.ShowSelectedID(matchingVariant.id);
      } else if (event.target.hasAttribute("gallery_relevant")) {
        this.gallery.ShowSelectedType(event.target.value || null);
      }
    }
    if (matchingVariant) {
      this.querySelector('input[name="id"]').value = matchingVariant.id;

      this.dispatchEvent(
        new CustomEvent("change-variant", {
          detail: { id: matchingVariant.id },
          bubbles: true,
        })
      );
    }
  }
}

customElements.define("product-form", ProductFormElement);
